import type { Product } from '../../api/products';

// terminal layout (jobb/bal/univerzális) + type (normál/vékony/Ford/amerikai),
// matching the legacy "saru" text built from jobb_bal + saru codes.
const LAYOUT: Record<number, string> = { 1: 'jobb +', 2: 'bal +', 3: 'univerzális' };
const TERMINAL: Record<number, string> = { 1: 'normál saru', 2: 'vékony saru', 3: 'Ford saru', 4: 'amerikai saru' };

function saruText(p: Product): string {
	const l = LAYOUT[p.terminal_layout];
	const t = TERMINAL[p.terminal_type];
	if (p.terminal_layout === 3) return l || '';
	return [l, t].filter(Boolean).join(', ');
}

interface Props {
	product: Product;
	/** When set, render a price + order button. */
	onOrder?: (product: Product) => void;
}

export default function AkkuBox({ product, onOrder }: Props) {
	const isStar = /bären polar plus/i.test(product.brand) || /bären polar plus/i.test(product.name);
	const dims = [product.length, product.width, product.height].filter(Boolean).join(' × ');
	const saru = saruText(product);

	return (
		<div className="akkubox">
			<div className="akkubox__head">
				<span className="akkubox__marka">
					{isStar && <img className="star" src="/img/icons/akkubox-star.png" alt="" />}
					{product.brand} {product.name?.replace(product.brand, '').trim()}
				</span>
				<span className="akkubox__volt">{product.voltage}V / {product.capacity}Aó</span>
			</div>
			<div className="akkubox__body">
				{!!product.cca && (
					<div className="akku-spec">
						<span className="akku-spec__val">{product.cca}A</span>
						<span className="akku-spec__lbl">indítóáram</span>
					</div>
				)}
				{saru && (
					<div className="akku-spec">
						<span className="akku-spec__val">{saru}</span>
						<span className="akku-spec__lbl">saru</span>
					</div>
				)}
				{dims && (
					<div className="akku-spec">
						<span className="akku-spec__val">{dims}</span>
						<span className="akku-spec__lbl">méret (h × sz × m)</span>
					</div>
				)}
			</div>
			{onOrder && (
				<div className="akkubox__foot">
					<span className="akkubox__price">{Number(product.price).toLocaleString('hu-HU')} Ft</span>
					<button type="button" className="btn" onClick={() => onOrder(product)}>Megrendelés</button>
				</div>
			)}
		</div>
	);
}
